/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const getExamRankingSharePic = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUIZ_RANKING_SHARE_PIC, data).then((res: IResponse<IOutput>) => {
        return res.data as IOutput;
    });
};

export const getExamRankingSharePicFull = (data: IInput): Promise<IResponse<IOutput>> => {
	return fetchData(Api.QUIZ_RANKING_SHARE_PIC, data);
};